interface SectionDividerProps {
  label: string;
  badge?: string;
}

export const SectionDivider = ({ label, badge }: SectionDividerProps) => {
  return (
    <div className="flex items-center gap-2 pt-2 pb-0.5">
      <span className="text-[11px] font-semibold tracking-[0.05em] uppercase text-muted-foreground">
        {label}
      </span>
      {badge && (
        <span className="text-[10px] font-semibold px-1.5 py-px rounded-lg bg-muted text-muted-foreground tracking-[0.03em]">
          {badge}
        </span>
      )}
      <span className="flex-1 h-0.5 bg-border" />
    </div>
  );
};
